












import Vue from 'vue';
import { Modal, ModalMixin } from 'mycorems-app-shared';

export default Vue.extend({
  mixins: [ModalMixin],
  props: {
    title: {
      type: String,
      default: 'Get Started!',
    },
  },
  components: {
    Modal,
  },
});
